import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import dpimg from "../../assets/img/dpmain.png";
import { useAuth } from "provider/AuthContext";
import apiCall from "components/Api/api";
import { useToast } from "provider/ToastProvider";
import { handleError } from "components/Api/handleError";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { useHomeContext } from "provider/HomeProvider";
import { useOperatorProfileContext } from "provider/OperatorProfileProvider";
import { useParksViewContext } from "provider/ParkViewProvider";
import { useProfileContext } from "provider/ProfileProvider";
import { useWishListContext } from "provider/WishListProvider";
import { useMasterContext } from "provider/MasterProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";


const SharedsafariCard = ({ safari, page }) => {
  const { isLoggedIn, logout, userProfile } = useAuth();
  const { parksWithSlug, safariCategory } = useMasterContext();
  const { sharedSafariData, organizeSafari, sharedSafariDispatch } = useSharedSafariContext();
  const { shareSafaris, homeDispatch } = useHomeContext();
  const { opSharedSafari, operatorProfileDispatch } = useOperatorProfileContext();
  const { parkSharedSafariData, parksViewDispatch } = useParksViewContext();
  const { userSharedSafariOrg, userSharedSafariJoind, profileDispatch } = useProfileContext();
  const { sharedSafaries, wishListDispatch } = useWishListContext();
  const navigate = useNavigate();
  const { showWarningToast } = useToast();
  const [loading, setLoading] = useState();
  const [loadingUnJoin, setLoadingUnJoin] = useState();
  const [imageError, setImageError] = useState(false);

  const [organizerImageError, setOrganizerImageError] = useState(false);

  if (!safari) return null;

  const startDate = new Date(safari.start_date);
  const date = startDate.getDate();
  const month = startDate.toLocaleString("default", { month: "short" });


  const updatedList = (safari, newUser, list, source, action) => {

    const updated = list.map((item) => {
      if (item.slug !== safari.slug) return item;

      const currentUsers = item.interested_users || [];
      const currentCount = item.interseted_user_count || 0;


      if (action === 'join') {
        if (currentUsers.length >= 3) {

          return {
            ...item,
            have_you_joined: true,
            interseted_user_count: Math.max(currentCount + 1, 0),
          };
        } else {
          const userExists = currentUsers.some(
            (u) => u.username.toLowerCase() === newUser.username.toLowerCase()
          );

          return {
            ...item,
            have_you_joined: true,
            interested_users: userExists ? currentUsers : [...currentUsers, newUser],
            interseted_user_count: Math.max(currentCount + 1, 0),
          };
        }
      }



      if (action === 'unjoin') {
        if (currentUsers.length >= 3) {

          return {
            ...item,
            have_you_joined: false,
            interseted_user_count: Math.max(currentCount - 1, 0),
          };
        } else {

          return {
            ...item,
            have_you_joined: false,
            interested_users: currentUsers.filter(
              (u) => u.username.toLowerCase() !== newUser.username.toLowerCase()
            ),
            interseted_user_count: Math.max(currentCount - 1, 0),
          };
        }
      }

      return item;
    });

    return updated;
  };


  const updateSharedSafariList = (safari, newUser, list, source, action) => {
    const newList = updatedList(safari, newUser, list, source, action);


    switch (source) {
      case "sharesafari":
        sharedSafariDispatch({
          type: "SET_SHARED_SAFARI_DATA",
          payload: newList,
        });
        break;
      case "home":
        homeDispatch({
          type: "SET_HOME_SHARE_SAFARI",
          payload: newList,
        });
        break;
      case "operatorProfile":
        operatorProfileDispatch({
          type: "SET_OPERATOR_SHARED_SAFARI_DATA",
          payload: newList,
        });
        break;
      case "userProfile":
        operatorProfileDispatch({
          type: "SET_OPERATOR_SHARED_SAFARI_DATA",
          payload: newList,
        });
      case "parkShareSafari":
        parksViewDispatch({
          type: "SET_PARKS_VIEW_SHARED_SAFARI_DATA",
          payload: newList,
        });
      case "userProfileOrganized":
        profileDispatch({
          type: "SET_USER_SF_ORG_DATA",
          payload: newList,
        });
      case "userProfileJoined":
        profileDispatch({
          type: "SET_USER_SF_JOIN_DATA",
          payload: newList,
        });
      case "sharesafariWishList":
        wishListDispatch({
          type: "SET_WISHLIST_SHARED_SAFARI_DATA",
          payload: newList,
        });
        break;
      default:
        console.warn(`Unhandled source in updateSharedSafariList: ${source}`);
        break;
    }
  };


  const joinSharedSafari = async (safari) => {
    try {
      setLoading(true);

      const response = await apiCall({
        url: `sharesafari/${safari?.slug}/join`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }


      const apiData = response.data;

      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {

        const newUser = {
          username: userProfile.username,
          name: userProfile.name,
          email: userProfile.email,
          is_safari_operator: userProfile.is_safari_operator,
          user_handle: userProfile.user_handle,
          gender: userProfile.gender,
          account_type: userProfile.account_type,
          gender_privacy: userProfile.gender_privacy,
          email_privacy: userProfile.email_privacy,
          status: userProfile.status,
          profile_display_image: userProfile.profile_display_image,
          cover_display_image: userProfile.cover_display_image,
          display_name: userProfile.display_name,
          is_followed: userProfile.is_followed,
          user_activity_count: userProfile.user_activity_count,
          operator_slug: userProfile.operator_slug,
        };

        if (page === 'sharesafari') {
          updateSharedSafariList(safari, newUser, sharedSafariData, page, 'join');
        }
        if (page === 'home') {
          updateSharedSafariList(safari, newUser, shareSafaris, page, 'join');
        }
        if (page === 'operatorProfile') {
          updateSharedSafariList(safari, newUser, opSharedSafari, page, 'join');
        }
        if (page === 'userProfile') {
          updateSharedSafariList(safari, newUser, opSharedSafari, page, 'join');
        }
        if (page === 'parkShareSafari') {
          updateSharedSafariList(safari, newUser, parkSharedSafariData, page, 'join');
        }
        if (page === "userProfileOrganized") {
          updateSharedSafariList(safari, newUser, userSharedSafariOrg, page, 'join');
        }
        if (page === "userProfileJoined") {
          updateSharedSafariList(safari, newUser, userSharedSafariJoind, page, 'join');
        }
        if (page === "sharesafariWishList") {
          updateSharedSafariList(safari, newUser, sharedSafaries, page, 'join');
        }

      } else {
        // Catch unexpected success payload with status ≠ 1
        console.warn("Unexpected API status:", apiData?.message);
        showWarningToast(apiData?.message);
      }
    } catch (error) {
      // Optionally dispatch network error

      handleError(error, logout, navigate);
    } finally {
      setLoading(false);
    }
  };

  const unJoinSharedSafari = async (safari) => {
    try {
      setLoadingUnJoin(true);

      const response = await apiCall({
        url: `sharesafari/${safari?.slug}/unjoin`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;
      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {

        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {
        const newUser = {
          username: userProfile.username,
          name: userProfile.name,
          email: userProfile.email,
          is_safari_operator: userProfile.is_safari_operator,
          user_handle: userProfile.user_handle,
          gender: userProfile.gender,
          account_type: userProfile.account_type,
          gender_privacy: userProfile.gender_privacy,
          email_privacy: userProfile.email_privacy,
          status: userProfile.status,
          profile_display_image: userProfile.profile_display_image,
          cover_display_image: userProfile.cover_display_image,
          display_name: userProfile.display_name,
          is_followed: userProfile.is_followed,
          user_activity_count: userProfile.user_activity_count,
          operator_slug: userProfile.operator_slug,
        };
        if (page === 'sharesafari') {
          updateSharedSafariList(safari, newUser, sharedSafariData, page, 'unjoin');
        }
        if (page === 'home') {
          updateSharedSafariList(safari, newUser, shareSafaris, page, 'unjoin');
        }
        if (page === 'operatorProfile') {
          updateSharedSafariList(safari, newUser, opSharedSafari, page, 'unjoin');
        }
        if (page === 'userProfile') {
          updateSharedSafariList(safari, newUser, opSharedSafari, page, 'unjoin');
        }
        if (page === 'parkShareSafari') {
          updateSharedSafariList(safari, newUser, parkSharedSafariData, page, 'unjoin');
        }
        if (page === "userProfileOrganized") {
          updateSharedSafariList(safari, newUser, userSharedSafariOrg, page, 'unjoin');
        }
        if (page === "userProfileJoined") {
          updateSharedSafariList(safari, newUser, userSharedSafariJoind, page, 'unjoin');
        }
        if (page === "sharesafariWishList") {
          updateSharedSafariList(safari, newUser, sharedSafaries, page, 'unjoin');
        }
      }
    } catch (error) {
      // Optionally dispatch network error
      handleError(error, logout, navigate);
    } finally {
      setLoadingUnJoin(false);
    }
  };

  const fetchSafariDetails = async (safariSlug) => {
    try {
      const response = await apiCall({
        url: `sharesafari/${safariSlug}/view`,
        method: "GET",
      });

      if (response.status !== 200) throw new Error(`Unexpected status: ${response.status}`);

      const apiData = response.data;

      if (apiData?.errors) {
        console.error("errors:", apiData.errors)
        return;
      }

      const data = apiData?.data;
      return data;

    } catch (error) {
      handleError(error, logout, navigate);
    } finally {

    }
  };

  const updateSafari = async (safari) => {
    // showWarningToast("comming soon")
    // return
    try {
      const safari_details = await fetchSafariDetails(safari?.slug);

      const get_park = parksWithSlug?.find(
        (park) => park.slug === safari_details?.park_slug
      );

      const get_staycategory = safariCategory?.find(
        (cat) => cat.label === safari_details?.stay_category_display
      );

      const setUpdate = {
        slug: safari_details?.slug,
        share_safari_title: safari_details?.share_safari_title ?? organizeSafari.share_safari_title,
        park_id: get_park?.value ?? organizeSafari.park_id,
        start_date: safari_details?.start_date ?? organizeSafari.start_date,
        end_date: safari_details?.end_date ?? organizeSafari.end_date,
        no_of_safari: safari_details?.no_of_safari ?? organizeSafari.no_of_safari,

        // step-2
        share_safari_agenda_id: safari_details?.share_safari_agenda_id ?? organizeSafari.share_safari_agenda_id,
        stay_category_id: get_staycategory?.value ?? organizeSafari.stay_category_id,
        estimate_price_min: safari_details?.estimate_price_min ?? organizeSafari.estimate_price_min,
        estimate_price_max: safari_details?.estimate_price_max ?? organizeSafari.estimate_price_max,
        total_seat: safari_details?.total_seat ?? organizeSafari.total_seat,
        share_seat: safari_details?.share_seat ?? organizeSafari.share_seat,

        // step-3
        shared_safari_image: null,
        safari_plan: safari_details?.safari_plan ?? organizeSafari.safari_plan,
        safariPhotoUrl: safari_details?.shared_image_path ?? organizeSafari.safariPhotoUrl,
      };

      const safari_type = safari_details?.types;

      if (safari_type === "Share Safari") {
        sharedSafariDispatch({
          type: "UPDATE_ORGANIZE_SHARE_SAFARI",
          payload: setUpdate,
        });
        sharedSafariDispatch({
          type: "ORGANIZE_SF_SET_STEP",
          payload: 1,
        });
        sharedSafariDispatch({
          type: "ORGANIZE_SHARE_SAFARI_TOGGLE",
          payload: true,
        });


      }
    } catch (error) {
      console.error("Failed to update safari:", error);
    }
  };


  return (
    <div className="sharesafri-card">
      <div className="flotingdate">
        <div className="icons text-center">
          <p className="mb-0">{month}</p>
          <p className="mb-0">{date}</p>
        </div>
      </div>

      {safari.types === "Fixed Departure" && (
        <div className="fixed-depart">
          <p>Fixed Departure</p>
        </div>
      )}

      <div className="shareimg">
        <Link to={`/sharedsafari/${safari.organized_slug}/${safari.slug}`}>
          {imageError || !safari.shared_image_path ? (

            <picture className="position-relative w-100 h-100">
              <source srcSet="/img/placeholder.jpg" type="image/jpg" />
              <img
                src="/img/placeholder.jpg"
                className="d-block w-100 h-100"
                alt="banner"
                loading="lazy"
                style={{ objectPosition: "center" }}
              />
            </picture>
          ) : (
            <img
              src={safari.shared_image_path}
              alt="banner"
              onError={() => setImageError(true)}
            />
          )}
        </Link>
      </div>

      <div className="card_body">
        <div className="top_seats">
          <Row className="safari justify-content-between pt-2">
            <Col className="safarinum d-flex gap-2 align-items-center">
              <p className="text_safari">SAFARI</p>
              <h6 className="number-safari">{safari.no_of_safari}</h6>
            </Col>
            <Col className="safarinum d-flex gap-2 align-items-center justify-content-center">
              <p className="text_safari">SEATS</p>
              <h6 className="number-safari">{safari.share_seat}</h6>
            </Col>
          </Row>
        </div>

        <div className="titleDate">
          <h6>
            <Link to={`/park/${safari.park_slug}`}>{safari.park_title}</Link>
          </h6>

          <div className="orgnizer">
            <p>
              Organized by:
              {safari?.is_safari_operator ?
                <Link to={`/operator/${safari.organized_slug}/profile`} style={{ color: '#09422D' }}><strong>{safari.organized_by_name}</strong></Link>
                :
                <Link to={`/profile/user/${safari.organized_slug}`} style={{ color: '#09422D' }}><strong>{safari.organized_by_name}</strong></Link>
              }
            </p>
          </div>
        </div>

        <div className="footer_card row pb-2 px-2 align-items-center">
          <Col xs={6}>
            <div className="users">
              {safari?.interested_users.map((user) => (
                <Link to={user?.is_safari_operator ? `/operator/${user?.user_handle}/profile` : `/profile/user/${user?.user_handle}`} key={user?.user_handle}>
                  <img
                    src={
                      organizerImageError || !user.profile_display_image
                        ? dpimg
                        : user.profile_display_image
                    }
                    alt="Organizer"
                    className="rounded-circle bg-info"
                    onError={() => setOrganizerImageError(true)}
                  />
                </Link>
              ))}
              {Number(safari?.interseted_user_count) > 3 && (
                <div
                  className="roundes_countuser"

                >
                  +{safari?.interseted_user_count - 3}
                </div>
              )}
            </div>
          </Col>

          <Col xs={6} className="text-end">
            <div className="btns-safaries">
              {isLoggedIn ? (
                <>
                  {safari?.organized_slug === userProfile?.user_handle ?
                    <div className="safari text-center">
                      <div className="joinsafari leavesafrai">
                        <Link
                          onClick={(e) => {
                            if (loading) {
                              e.preventDefault();
                              return;
                            }
                            updateSafari(safari);
                          }}
                          disabled={true}
                        >
                          Update
                        </Link>
                      </div>
                    </div>
                    :
                    <>
                      {
                        safari?.have_you_joined ? (
                          <div className="safari text-center">
                            <div className="joinsafari leavesafrai">
                              <Link
                                onClick={(e) => {
                                  if (loading) {
                                    e.preventDefault();
                                    return;
                                  }
                                  if (safari?.types === "Fixed Departure") {
                                    navigate(`https://play.google.com/store/apps/details?id=com.mediarc.walkintothewild`)
                                  } else {
                                    unJoinSharedSafari(safari);
                                  }

                                }}
                                disabled={loadingUnJoin}
                              >
                                {safari?.types === "Fixed Departure" ?
                                  (
                                    <span className="d-flex gap-3 justify-content-center">
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        size="lg"
                                       

                                      />App
                                    </span>
                                  )

                                  : 'Leave Safari'}

                              </Link>
                            </div>
                          </div>
                        ) : (
                          <div className="safari text-center">
                            <div className="joinsafari">
                              <Link
                                onClick={(e) => {
                                  if (loadingUnJoin) {
                                    e.preventDefault();
                                    return;
                                  }
                                  if (safari?.types === "Fixed Departure") {
                                    window.location.href = "https://play.google.com/store/apps/details?id=com.mediarc.walkintothewild";
                                  } else {
                                    joinSharedSafari(safari);
                                  }
                                }}
                                disabled={loading}
                              >
                                {safari?.types === "Fixed Departure" ?
                                  (
                                    <span className="d-flex gap-3 justify-content-center">
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        size="lg"
                                       

                                      /> App
                                    </span>
                                  )
                                  : 'Join Safari'}
                              </Link>
                            </div>
                          </div>
                        )

                      }
                    </>
                  }
                </>
              ) : (

                <div className="safari text-center">
                  <div className="joinsafari">
                    <Link
                      to={`/log-in?authclient=google&referrer=${encodeURIComponent(
                        `/sharesafari`
                      )}`}
                    >
                      Join Safari
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </div>
      </div>
    </div>
  );
};

export default SharedsafariCard;
